window.drawBidHistories = (arr) => {
    const data = new google.visualization.DataTable();
    data.addColumn('date', '時刻');
    data.addColumn('number', '価格');
    data.addColumn('string', 'メモ');
    data.addRows(JSON.parse(arr).map(([date, price, auto]) => [new Date(date), price, auto ? '自動入札' : '入札']));
    const options = {
        width: 900,
        height: 500,
        connectSteps: false,
        isStacked: true,
        hAxis: {
            format: 'MM/dd HH:mm',
            gridlines: {count: 15}
        },
        vAxis: {
            gridlines: {color: 'none'},
            format: 'decimal',
            minValue: 0,
            displayExactValues: true,
        }
    };

    const chart = new google.visualization.AnnotatedTimeLine(document.getElementById('chart_div'));

    chart.draw(data, options);
};